/**
 * @desc add
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.AppDomainRoleRpcRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/app/role/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
